// ContentTypeNav.js
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../routes/routes'; // Import routes from routes.js
import styled from 'styled-components';

import dropdownIcon from 'assets/images/icon-dropdown.svg';

const StyledContentTypeNav = styled.div`
	select {
		background: ${(props) => props.backgroundColor || '#fff'};
		padding: 0.62rem 1.44rem;
		position: relative;
		display: inline-flex;
		appearance: none;
		outline: none;
		background-image: url(${dropdownIcon});
		background-repeat: no-repeat;
		background-position: right 14px center;
		background-size: 16px;
		padding-right: 3rem;
		color: white;
		&:focus {
			outline: 3px solid #ffb7b7;
			outline: default;
		}
		option {
			font-weight: 300;
		}
	}
`;

function ContentTypeNav({ type }) {
	const [filteredRoutes, setFilteredRoutes] = useState([]);
	const [currentNavColor, setCurrentNavColor] = useState('#fff');
	const location = useLocation(); // Hook to get current location path
	const navigate = useNavigate(); // Hook to perform navigation

	useEffect(() => {
		// Filter routes by the type property, then reverse the order
		const typeRoutes = routes.filter((route) => route.type === type).reverse();
		setFilteredRoutes(typeRoutes);

		// Find the active route
		const activeRoute = typeRoutes.find((route) => route.path === location.pathname);

		if (activeRoute) {
			// Set the current navigation color from the active route
			setCurrentNavColor(activeRoute.fullNavColor || '#fff');
		} else if (typeRoutes.length > 0) {
			// If no active route found but we have routes of this type, use the first one's color
			setCurrentNavColor(typeRoutes[0].fullNavColor || '#fff');
		}
	}, [location, type]); // Re-run this effect when location or type changes

	const handleSelectChange = (event) => {
		navigate(event.target.value); // Navigate to the selected URL
	};

	return (
		<StyledContentTypeNav className="pb-10" backgroundColor={currentNavColor}>
			<select onChange={handleSelectChange} value={location.pathname}>
				{filteredRoutes.map((route) => (
					<option key={route.path} value={route.path}>
						{route.label || route.name}
					</option>
				))}
			</select>
		</StyledContentTypeNav>
	);
}

export default ContentTypeNav;
